export enum BaseSurchargesMethodOfCalculation {
  igz = 'igz',
  bab = 'bab',
}

export enum BaseIndustrySurchargesDateType {
  month = 'month',
  week = 'week',
}
